/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSpendingRequestDto
 */
export interface GetSpendingRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GetSpendingRequestDto
     */
    id?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSpendingRequestDto
     */
    years?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSpendingRequestDto
     */
    getAllResults?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSpendingRequestDto
     */
    topX?: number;
}

/**
 * Check if a given object implements the GetSpendingRequestDto interface.
 */
export function instanceOfGetSpendingRequestDto(value: object): value is GetSpendingRequestDto {
    return true;
}

export function GetSpendingRequestDtoFromJSON(json: any): GetSpendingRequestDto {
    return GetSpendingRequestDtoFromJSONTyped(json, false);
}

export function GetSpendingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSpendingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'years': json['years'] == null ? undefined : json['years'],
        'getAllResults': json['getAllResults'] == null ? undefined : json['getAllResults'],
        'topX': json['topX'] == null ? undefined : json['topX'],
    };
}

export function GetSpendingRequestDtoToJSON(json: any): GetSpendingRequestDto {
    return GetSpendingRequestDtoToJSONTyped(json, false);
}

export function GetSpendingRequestDtoToJSONTyped(value?: GetSpendingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'years': value['years'],
        'getAllResults': value['getAllResults'],
        'topX': value['topX'],
    };
}

